import React, { useEffect, useState } from "react";
import { elementType, object, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { parseUrl } from "query-string";

import ProfileMenu from "../../atoms/ProfileMenu";
import ProfileMenuMobile from "../../atoms/ProfileMenuMobile";
import NotLoggedInView from "../NotLoggedInView";

import "./profile-container.m.css";

const ProfileContainer = ({ member, type, authHost, children, sketchesHost, currentPath }) => {
  const [renderComponent, setRenderComponent] = useState(false);
  const [callbackUrl, setCallbackUrl] = useState(sketchesHost);
  const [redirectUrl, setRedirectUrl] = useState(sketchesHost);

  const params = parseUrl(currentPath);

  const getRedirectUrl = (defaultRedirectUrl) => {
    const redirectUrl = get(params, ["query", "redirect-url"], defaultRedirectUrl);
    setRedirectUrl(redirectUrl);
  };

  useEffect(() => {
    setCallbackUrl(get(params, ["query", "callback-url"], global.location.origin));
    if (
      params.url.includes("sign-in-page") ||
      params.url.includes("sign-up-page") ||
      params.url.includes("forgot-password")
    ) {
      getRedirectUrl(sketchesHost);
    } else {
      params.url.includes("verify-email") ? getRedirectUrl(sketchesHost) : getRedirectUrl(global.location.href);
    }
  }, [params]);

  useEffect(() => {
    setRenderComponent(true);
  }, []);

  const loggedInView = () => (
    <React.Fragment>
      <ProfileMenuMobile member={member} type={type} />

      <div styleName="wrapper">
        <ProfileMenu member={member} type={type} />

        {children({ member: member })}
      </div>
    </React.Fragment>
  );

  return (
    <div styleName="container">
      {renderComponent && (
        <>
          {member && member["verification-status"] ? (
            loggedInView()
          ) : (
            <NotLoggedInView authHost={authHost} redirectUrl={redirectUrl} callbackUrl={callbackUrl} />
          )}
        </>
      )}
    </div>
  );
};

ProfileContainer.propTypes = {
  member: object,
  type: string.isRequired,
  children: elementType,
  authHost: string,
  currentPath: string,
  sketchesHost: string,
};

const mapStateToProps = (state) => ({
  member: state.member,
  authHost: get(state, ["qt", "config", "publisher-attributes", "auth_host"], null),
  sketchesHost: get(state, ["qt", "config", "sketches-host"], "https://www.prothomalo.com"),
});

export default connect(mapStateToProps, null)(ProfileContainer);
